import React from "react"
import ReactPlayer from "react-player"
import styled from "styled-components"
import Layout from "../components/layout"
import Section from "../components/layout/section"
import media from "../utils/mediaQueries"

const { se, tablet } = media

const videos = [
  {
    title: "Overview",
    url: "https://vimeo.com/524096891/6628b478a9",
  },
  {
    title: "Sending Campaigns",
    url: "https://vimeo.com/523612056/bff229420e",
  },
  {
    title: "Managing Contacts",
    url: "https://vimeo.com/523612177/0df23eca1b",
  },
  {
    title: "Importing Contacts",
    url: "https://vimeo.com/523612148/440f115655",
  },
  {
    title: "Exploring the Builder",
    url: "https://vimeo.com/523612361/dc7b76521e",
  },
  {
    title: "Intro to Automation",
    url: "https://vimeo.com/523612227/fc570776a0",
  },
  {
    title: "Advanced Automation",
    url: "https://vimeo.com/523612256/4a1b6d67f1",
  },
  {
    title: "Creating and Using Offers",
    url: "https://vimeo.com/524496427/401eaa3e25",
  },
  {
    title: "Creating Keywords",
    url: "https://vimeo.com/523612123/7e2313c5d0",
  },
  {
    title: "Intro to Mobile Pages",
    url: "https://vimeo.com/523611999/7df8ddc7df",
  },
]

const VideoGalleryPage = () => (
  <Layout>
    <Section>
      <h2>MindMe Video Gallery</h2>
      <p>
        We've created a gallery of videos to turn you in the a MindMe
        Professional.
      </p>
    </Section>
    <Section>
      <VideosContainer>
        {videos.map(({ title, url }) => (
          <VideoWrapper>
            <div className="player-wrapper">
              <ReactPlayer
                url={url}
                width="100%"
                height="100%"
                className="react-player"
                controls
              />
            </div>
            <h3>{title}</h3>
          </VideoWrapper>
        ))}
      </VideosContainer>
    </Section>
  </Layout>
)

export default VideoGalleryPage

const VideosContainer = styled.div`
  ${se &&
    se`
  display: flex;
  `}
  ${tablet &&
    tablet`
    flex-wrap: wrap;
    justify-content: space-between;
    `}
`

const VideoWrapper = styled.div`
  margin-bottom: 50px;

  .player-wrapper {
    position: relative;
    padding-top: 56.25%;
    margin-bottom: 20px;
    box-shadow: 0 45px 25px -30px rgba(0, 0, 0, 0.2),
      0 2px 5px rgba(0, 0, 0, 0.25);
  }
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }

  ${tablet &&
    tablet`
   width: 48%;
  `}
`
